import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface BrandProductHook {
  id: string;
  brand_id: string;
  user_id: string;
  product: string;
  description?: string;
  type: string;
  funnel_stage: string;
  landing_page_link?: string;
  images?: string[];
  tags?: string[];
  more_tags?: string[];
  tag3?: string[];
  category_id?: string;
  slug?: string;
  price?: number | null;
  price_range_from?: number | null;
  price_range_to?: number | null;
  created_at: string;
  updated_at: string;
}

export const useBrandProductsHooks = (brandId: string) => {
  const fetchBrandProducts = async (): Promise<BrandProductHook[]> => {
    const { data, error } = await supabase
      .from('brand_products_hooks')
      .select('*')
      .eq('brand_id', brandId)
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    const parseJsonbArray = (value: any): string[] => {
      if (Array.isArray(value)) return value.map(String);
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed.map(String) : [];
        } catch {
          return [];
        }
      }
      return [];
    };

    return (data || []).map(item => ({
      ...item,
      images: parseJsonbArray(item.images),
      tags: parseJsonbArray(item.tags),
      more_tags: parseJsonbArray(item.more_tags),
      tag3: parseJsonbArray(item.tag3)
    }));
  };

  return useQuery({
    queryKey: ['brand-products-hooks', brandId],
    queryFn: fetchBrandProducts,
    enabled: !!brandId,
  });
};